import { useRouter } from 'next/router'
import { Arguments } from 'swr'
import useSWRMutation, { SWRMutationConfiguration, SWRMutationResponse } from 'swr/mutation'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { CreateTopicInterface, TopicInterface } from 'modules/community/types/topic-interface'

interface UseCreateTopicOptions {
  config?: SWRMutationConfiguration<TopicInterface, Error>
}

export const useCreateTopic = ({ config }: UseCreateTopicOptions = {}): SWRMutationResponse<
  TopicInterface,
  Error,
  Record<string, unknown> | string | false | (() => Arguments) | null | undefined,
  CreateTopicInterface
> => {
  const { query } = useRouter()
  const { communityPath } = query

  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    TopicInterface,
    CreateTopicInterface
  >({
    method: RequestMethodsEnum.post,
    badRequestHandler: () => {},
  })

  return useSWRMutation(
    communityPath ? `${COMMUNITY_API_PREFIX}/${communityPath}/topic` : null,
    adaptFetcherToSWRMutationFn<TopicInterface, CreateTopicInterface>(fetcher),
    config,
  )
}
